import type { BaseReactProps, ReactNodeDef } from '@shared/node-v1.0.0'
import { lazy } from 'react'

export type Props = BaseReactProps

export default {
	hashTag: '#pre-release',
	module: { dynamic: lazy(() => import('../component')) },
	disableCustomProps: true,
} satisfies ReactNodeDef
